import React, { useEffect, useState, useRef } from 'react';
import TextInput from '../../../../../Shared/TextInput/TextInput';

const ChooseNumber = (props) => {
const [error , setError] = useState(props.error)
const ref = useRef(null);

const isGolan = process.env.staticWebSiteUrl?.includes('golan');


  useEffect(() => {
    setError(props.error);
  }, [props.error]);
  useEffect(() => {
    if (!props.isDisable) {
      if (ref.current) {
        const offsetTop = ref.current.offsetTop ;
        window.scrollTo({top: offsetTop , behavior: 'smooth'});
      }
    }
  }, [props.isDisable]);

  useEffect(() => {
    if ((!isGolan && props.cellularSetting?.transferPhoneNumberInfo?.isCellcomPhone) || (isGolan && props.cellularSetting?.transferPhoneNumberInfo?.isGolanPhone)) {
      if (ref.current) {
        const offsetTop = ref.current.offsetTop ;
        window.scrollTo({top: offsetTop , behavior: 'smooth'});
      }
    }
  }, [props.cellularSetting?.transferPhoneNumberInfo?.isCellcomPhone || props.cellularSetting?.transferPhoneNumberInfo?.isGolanPhone]);

  function onPhoneChange(value){
    setError('');
    const regex = new RegExp('^0(5[012345678]|6[47]){1}(\\-)?[^0\\D]{1}\\d{6}$');
    const isValid = regex.test(value);
    props.onPhoneChange({phoneNumber: value, isValid: isValid });
    if(!isValid){
      setError('חובה להזין מספר טלפון תקין');
    }
  }

  function onSelectPhone(value){
    props.onPhoneChange({phoneNumber: value, isValid: true })
  }

  return (
    <div ref={ref} className={`choosing-phone-numbers ${props.isDisable ? 'disabled' : ''}`}>
      {props.isDisable && <div className='disabled'></div>}
      <h2 className='title'>{props.cellularSetting?.phoneType == "new"  ? "בואו נבחר את המספר החדש" : "איזה מספר אנחנו מניידים?" }</h2>
      <div className='phone-numbers-wrapper'>
        {props.cellularSetting?.phoneType == "new" ?
            <div className='new-phone-numbers'>
            {props.cellularSetting?.newPhoneNumbers?.map((phoneNumber, i) => {
              const phoneNumberFormat = phoneNumber.substring(0, 3) + '-' + phoneNumber.substring(3);
              return(<div key={i}  onClick={() => {onSelectPhone(phoneNumber)}} className={`new-phone-number ${phoneNumber == props.cellularSetting?.phoneNumber ? 'selected' : ''}`} >{phoneNumberFormat}</div>)
              })}
            {/* <p className='get-numbers-btn'>לא התחברתם? <a href='#' onClick={() => {props.onClickGetMorePhoneNumbers()}}>יש פה עוד מספרים חדשים</a></p> */}
          </div> :
          <div className='transfer-number-input'>
            <TextInput
            error={error}
            onChange={(e) => {onPhoneChange(e.target.value)}}
            value={props.cellularSetting?.phoneNumber ?? ""}
            type='tel'
            placeholder='מספר טלפון'
            id='phone'
            name='phone'
            minLength='9'
            maxLength='10'
            autoComplete='off'
            required='required'
            />
          </div>

        }
      </div>
      {(!isGolan && props.cellularSetting?.transferPhoneNumberInfo?.isCellcomPhone) || (isGolan && props.cellularSetting?.transferPhoneNumberInfo?.isGolanPhone) &&
      <p className='error-wrapper'><span className='bold-error-text'>המנוי הזה כבר חלק מהמשפחה</span>
      <span>אנחנו רואים שהמספר הזה כבר שייך ל{window.Config.brand_Name_HE},</span>
      <span>כדאי לבדוק שזה המספר הנכון ולנסות שוב</span>
      </p>}
    </div>
  );
};

export default ChooseNumber;
